import * as React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ClientAreaCtrl from "../../components/clientarea/clientAreaCtrl";
import { CKYCUpdate } from "../../components/clientarea/serviceRequest/CKYC/ckycUpdate";
import { DISBooklet } from "../../components/clientarea/serviceRequest/disBooklet/disBooklet";
import { DPScheme } from "../../components/clientarea/serviceRequest/dpScheme/dpScheme";
import { EmailMobileModification } from "../../components/clientarea/serviceRequest/emailMobileModification/emailMobileModification";
import { FatcaUpdate } from "../../components/clientarea/serviceRequest/fatcaUpdate/fatcaUpdate";
import { IncomeDeclaration } from "../../components/clientarea/serviceRequest/incomeDeclaration/incomeDeclaration";
import { POADownload } from "../../components/clientarea/serviceRequest/poaDownload/poaDownload";
import { SegmentActivation } from "../../components/clientarea/serviceRequest/segmentActivation/segmentActivation";
import AccountClosure from "../../components/clientarea/serviceRequest/accClosure/accClosure";
import AccReactivateCont from "../../components/clientarea/serviceRequest/accReactivate/accReactivateCont";
import { Bank } from "../../components/clientarea/serviceRequest/bankDetails/bankModification";
import { VerficationStage } from "../../components/clientarea/serviceRequest/verficationStage/verficationStage";

import { SRLayout } from "../../components/clientarea/serviceRequest/srLayout";
import PostLogin from "../postLogin";
import { AddressModification } from "../../components/clientarea/serviceRequest/addressModification/addressModification";
import { AccountPayment } from "../../components/clientarea/serviceRequest/accPayment/accPayment";
import { PaymentResponse } from "../../components/clientarea/serviceRequest/accPayment/paymentResponse";
import { Nomination } from "../../components/clientarea/serviceRequest/nomination/nomination";
import { Ddpi } from "../../components/clientarea/serviceRequest/ddpi/ddpi";
import { Smtf } from "../../components/clientarea/serviceRequest/smtf/smtf";
import { SegmentDeactivation } from "../../components/clientarea/serviceRequest/segmentDeactivation/segmentDeactivation";
import { EarlyPayIn } from "../../components/clientarea/serviceRequest/EarlyPayIn/EarlyPayIn";
const ClientRouting = (props: any) => {
  return (
    <div>
      <ClientAreaCtrl {...props} />
      <Switch>
        <PostLogin
          path="/clientarea/service-request/open"
          exact
          render={(props) => <SRLayout {...props} />}
        />
        {/* <PostLogin
          path="/clientarea/service-request/disBooklet"
          exact
          render={(props) => <SRLayout {...props} component={DISBooklet} />}
        /> */}
        {/* <PostLogin
          path="/clientarea/service-request/dpScheme"
          exact
          render={(props) => <SRLayout {...props} component={DPScheme} />}
        /> */}
        {/* <PostLogin
          path="/clientarea/service-request/poa-download"
          exact
          render={(props) => <SRLayout {...props} component={POADownload} />}
        /> */}
        <PostLogin
          path="/clientarea/service-request/fatcaUpdate"
          exact
          render={(props) => <SRLayout {...props} component={FatcaUpdate} />}
        />
        {/* <PostLogin
          path="/clientarea/service-request/BankUpdate"
          exact
          render={(props) => <SRLayout {...props} component={Bank} />}
        /> */}
        <PostLogin
          path="/clientarea/service-request/Nomination"
          exact
          render={(props) => <SRLayout {...props} component={Nomination} />}
        />
        {/* <PostLogin
          path="/clientarea/service-request/income-declaration"
          exact
          render={(props) => (
            <SRLayout {...props} component={IncomeDeclaration} />
          )}
        /> */}
        <PostLogin
          path="/clientarea/service-request/email-mobile-modification"
          exact
          render={(props) => (
            <SRLayout {...props} component={EmailMobileModification} />
          )}
        />
        <PostLogin
          path="/clientarea/service-request/segment-deactivation"
          exact
          render={(props) => (
            <SRLayout {...props} component={SegmentDeactivation} />
          )}
        />
        <PostLogin
          path="/clientarea/service-request/segment-activation"
          exact
          render={(props) => (
            <SRLayout {...props} component={SegmentActivation} />
          )}
        />
        <PostLogin
          path="/clientarea/service-request/account-closure"
          exact
          render={(props) => <SRLayout {...props} component={AccountClosure} />}
        />
        <PostLogin
          path="/clientarea/service-request/account-reactivation"
          exact
          render={(props) => (
            <SRLayout {...props} component={AccReactivateCont} />
          )}
        />
        <PostLogin
          path="/clientarea/service-request/ckyc-update"
          exact
          render={(props) => <SRLayout {...props} component={CKYCUpdate} />}
        />
        <PostLogin
          path="/clientarea/service-request/bank-modification"
          render={(props) => <SRLayout {...props} component={Bank} />}
        />
        <PostLogin
          path="/clientarea/service-request/address-modification"
          render={(props) => (
            <SRLayout {...props} component={AddressModification} />
          )}
        />
        {/* <PostLogin
          path="/clientarea/service-request/verficationStage"
          render={(props) => (
            <SRLayout {...props} component={VerficationStage} />
          )}
        /> */}

        <PostLogin
          path="/clientarea/service-request/account-payment"
          exact
          component={PaymentResponse}
        />

        <PostLogin
            path="/clientarea/service-request/ddpi"
            exact
            render={(props) => <SRLayout {...props} component={Ddpi} />}
        />

        <PostLogin
            path="/clientarea/service-request/smtf"
            exact
            render={(props) => <SRLayout {...props} component={Smtf} />}
        />
        <PostLogin
            path="/clientarea/service-request/early-payin"
            exact
            render={(props) => <SRLayout {...props} component={EarlyPayIn} />}
        />
      </Switch>
    </div>
  );
};
export default ClientRouting;
